module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAABXklEQVQoU3WSSyhEcRSHv3PnDqaUQTaKUmQhRQwrsqFZKCmUYqNMycpGycbCzk6EmabksbGxkRqPLeqqsZGyYoOSR4kGM/+jW2a6xNmd8/t951FH8ETTihZZsIDQB/gFElaG8ZMxucraxAs0RzUh0IUwr/AoyhRw/Rak/nxAPlxvDmha0UpLuAYcJyItrtgS1TWFYaDTicjBD6B1WWuMxSXwYpQO4+PBNuwDNQo9zykSpQHKpG5RCwN+ujM2h/40RwrV3jWB1/w0Fe82caBWQlG9AOLvBSzlpWgX2PUCKkyejsqcWwvFdNUFzpyINGRNzTGdFWX6O993bggzI+ZfoH9LfVfPHALVaZvG5IjcZ5v9OcEVG+NabmcodiJy7l3vX+DX0bk0B/BJGD9DQC9QIpA0sF4VZC95hx0MEBbDIIK6RyeBW1E2fK9sH0+QCsVoRxjC0IbwJMqOZdh0X+QLS+aQPZtLFmgAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/static/img/media_addr.png
// module id = U3wJ
// module chunks = 1